import React from 'react';
import PropTypes from 'prop-types';

function WatchNowTease({
  isFlagged,
  url,
}) {
  return (
    <div className="watch-now">
      {isFlagged && (
      <span className="watch-now__live-flag">
          &nbsp;
      </span>
      )}
      <a href={url}>
        <h1 className="watch-now__headline">WATCH: NBC NEWS NOW</h1>
      </a>
    </div>
  );
}

WatchNowTease.propTypes = {
  isFlagged: PropTypes.bool,
  url: PropTypes.string,
};

WatchNowTease.defaultProps = {
  isFlagged: true,
  url: 'https://www.nbcnews.com/now',
};

export { WatchNowTease };
